/**
 * @generated SignedSource<<78fba753a085467b5d86fcaf2e019010>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FeatureKey = "ADDITIONAL_LISTS" | "BIOMETRIC_LOCK" | "BUDGET" | "ESTATE_SEARCH" | "EXTENDED_ADDRESS_LOOKUP" | "FLOOD_MAP" | "HOME_FEED" | "HOME_OWNERSHIP" | "HOME_RECORDS" | "HOME_UPDATES" | "HOME_UPDATES_PUSH_ANNIVERSARY" | "HOME_UPDATES_PUSH_FLOOD" | "HOME_UPDATES_PUSH_HOME_VALUE" | "HOME_UPDATES_PUSH_PLANNING" | "HOME_UPDATES_PUSH_RATE_DECISION" | "HOME_UPDATES_PUSH_RENT_CHECK" | "HOME_UPDATES_PUSH_SOLD_NEAR_YOU" | "HOUSEHOLD_MONEY" | "JOURNEY_NUDGES" | "LISTING_PHOTO_IMPORT" | "LOCAL_KNOWLEDGE" | "NOISE_INSIGHT" | "PERSONA_JOURNEYS" | "REACHABLE_AREA_SCENE" | "REALTIME_PRESENCE" | "REAL_JOURNEY_TIMES" | "REMOTE_FETCH_IMPORT" | "VIEWINGS" | "VIEWING_NOTE_SUGGESTIONS" | "VOICE" | "%future added value";
export type FeatureKind = "EXPERIMENT" | "OPS" | "RELEASE" | "%future added value";
export type FeatureStage = "BETA" | "GA" | "INTERNAL" | "OFF" | "%future added value";
export type featureFlagMutationsSetStageMutation$variables = {
  key: FeatureKey;
  stage: FeatureStage;
};
export type featureFlagMutationsSetStageMutation$data = {
  readonly setStage: {
    readonly key: FeatureKey;
    readonly killed: boolean;
    readonly kind: FeatureKind;
    readonly percent: number;
    readonly stage: FeatureStage;
  };
};
export type featureFlagMutationsSetStageMutation = {
  response: featureFlagMutationsSetStageMutation$data;
  variables: featureFlagMutationsSetStageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "stage"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      },
      {
        "kind": "Variable",
        "name": "stage",
        "variableName": "stage"
      }
    ],
    "concreteType": "FeatureFlagState",
    "kind": "LinkedField",
    "name": "setStage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "killed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kind",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "featureFlagMutationsSetStageMutation",
    "selections": (v1/*: any*/),
    "type": "FeatureToggleMutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "featureFlagMutationsSetStageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "88da17cfdea7747c81ff4f364c3c6e4f",
    "id": null,
    "metadata": {},
    "name": "featureFlagMutationsSetStageMutation",
    "operationKind": "mutation",
    "text": "mutation featureFlagMutationsSetStageMutation(\n  $key: FeatureKey!\n  $stage: FeatureStage!\n) {\n  setStage(key: $key, stage: $stage) {\n    key\n    stage\n    killed\n    percent\n    kind\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a09af38e880fb0c094c8ae51bc2e3d1";

export default node;
